import React from "react";

import "animate.css";
import "./styles.css";

import Banner from "../../components/Banner";
import StatsSection from "../../components/StatsSection";
import Features from "../../components/Features";
import DetailedFeatures from "../../components/DetailedFeatures";
import Video from "../../components/Video";
import Testimonials from "../../components/Testimonials";
import SignPlan from "../../components/SignPlan";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";

import { Accordion } from "react-bootstrap";
import { commons } from "./commons";

function Presentation() {
  return (
    <>
      <Navbar />

      <main className="section-body presentation-page">
        <Banner />
        <StatsSection />
        <Features />
        <DetailedFeatures />

        <section id="video" className="presentation-section presentation-section-contrast">
          <div className="container presentation-shell px-4 px-lg-5 py-5">
            <div className="section-intro text-center mx-auto mb-5">
              <span className="section-kicker">Demonstracao</span>
              <h2 className="section-title">Veja a plataforma em acao</h2>
              <p className="section-description section-description-muted">
                Uma experiencia pensada para simplificar a operacao juridica, do
                cadastro inicial ao acompanhamento diario.
              </p>
            </div>
            <Video />
          </div>
        </section>

        <Testimonials />

        <section id="planos" className="presentation-section presentation-section-contrast">
          <SignPlan />
        </section>

        <section id="faq" className="presentation-section presentation-section-soft">
          <div className="container presentation-shell px-4 px-lg-5 py-5">
            <div className="section-intro text-center mx-auto mb-5 pb-3">
              <span className="section-kicker">FAQ</span>
              <h2 className="section-title">Perguntas frequentes</h2>
              <p className="section-description section-description-muted">
                Respostas objetivas para acelerar sua decisao e mostrar como o
                EasyVOG se encaixa na rotina do seu escritorio.
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-9">
                <Accordion className="custom-accordion">
                  {commons.map((common) => (
                    <Accordion.Item
                      key={common.id}
                      eventKey={common.title}
                      className="border-0 bg-transparent rounded-0"
                    >
                      <Accordion.Header className="py-2">
                        <span className="faq-question">
                          {common.title}
                        </span>
                      </Accordion.Header>
                      <Accordion.Body className="faq-answer">
                        <div dangerouslySetInnerHTML={{ __html: common.body }} />
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}

export default Presentation;
